import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react'
import { WorkPostSheetFormStep } from '../constants/wpsFormSteps'

export interface StepContextValue {
  step: WorkPostSheetFormStep
  setStep: Dispatch<SetStateAction<WorkPostSheetFormStep>>
}

export const StepContext = createContext<StepContextValue>({
  step: WorkPostSheetFormStep.Step1,
  setStep: () => {}
})

export function useStep(): StepContextValue {
  return useContext(StepContext)
}

export const StepProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [step, setStep] = useState<WorkPostSheetFormStep>(
    WorkPostSheetFormStep.Step1
  )

  const context = useMemo(() => ({ step, setStep }), [step])

  return <StepContext.Provider value={context}>{children}</StepContext.Provider>
}
